// extracted by mini-css-extract-plugin
export var alignText = "style-mod--align-text--fa1c0";
export var imageAspect = "style-mod--image-aspect--e55c0";
export var mediaTwoColumns = "style-mod--media-two-columns--f9128";
export var overlapImg = "style-mod--overlap-img--d98d5";
export var topAlignText = "style-mod--top-align-text--ae003";
export var twoColumns = "style-mod--two-columns--e5e8e";
export var twoColumnsContainerResponsive = "style-mod--two-columns-container-responsive--75298";
export var twoColumnsImg = "style-mod--two-columns-img--3b6f1";
export var twoColumnsItems = "style-mod--two-columns-items--1539b";
export var twoColumnsItemsReverse = "style-mod--two-columns-items-reverse--06e8d";
export var twoColumnsText = "style-mod--two-columns-text--ea760";
export var twoColumnsTextComplex = "style-mod--two-columns-text-complex--3f1a5";
export var twoColumnsTextComplexIcon = "style-mod--two-columns-text-complex-icon--4c129";
export var wordBreaksOff = "style-mod--word-breaks-off--b7014";